import { LoaderFunction } from 'react-router-dom'
import { compareDesc } from 'date-fns/compareDesc'

import { eventsApi } from '../../services/events'
import type { AppStore } from '../../store'
import { Events, EventStatus } from '../../types'

export const dashboardLoader = (store: AppStore) =>
  (async () => {
    const { data } = await store.dispatch(
      eventsApi.endpoints.listEvents.initiate(undefined, { forceRefetch: true })
    )
    if (!data)
      return {
        archived: [],
        ongoing: [],
        future: [],
        past: [],
      }

    const now = new Date()

    const archived: Events[] = []
    const past: Events[] = []
    const ongoing: Events[] = []
    const future: Events[] = []

    data.forEach(event => {
      if (event.status === EventStatus.Archived) {
        archived.push(event)
        return
      }

      const start = new Date(event.start)
      const end = new Date(event.end)
      if (end < now) {
        past.push(event)
      } else if (now >= start && now <= end) {
        ongoing.push(event)
      } else {
        future.push(event)
      }
    })

    return {
      archived,
      ongoing: ongoing.sort((a1, a2) => compareDesc(a1.start, a2.start)),
      future,
      past,
    }
  }) satisfies LoaderFunction
